export default "__VITE_ASSET__BsEksLIO__"